import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private exact
        key="pivot-table"
        path="/pivot-table/:id?"
        component={Page} />
];

export default Routes;